/* eslint-disable */
export default {
  monday: 'Lun.',
  tuesday: 'M',
  wednesday: 'Mié.',
  thursday: 'Jue.',
  friday: 'V',
  saturday: 'S',
  sunday: 'Dom.',
} as const;

// @key: @#@"monday"@#@ @source: @#@"M"@#@
// @key: @#@"tuesday"@#@ @source: @#@"T"@#@
// @key: @#@"wednesday"@#@ @source: @#@"W"@#@
// @key: @#@"thursday"@#@ @source: @#@"T"@#@
// @key: @#@"friday"@#@ @source: @#@"F"@#@
// @key: @#@"saturday"@#@ @source: @#@"S"@#@
// @key: @#@"sunday"@#@ @source: @#@"S"@#@
